var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,5.8a8.548,8.548,0,0,1-2.362.647,4.07,4.07,0,0,0,1.8-2.266,8.2,8.2,0,0,1-2.6.993,4.1,4.1,0,0,0-7.09,2.8,4.189,4.189,0,0,0,.095.935A11.6,11.6,0,0,1,3.4,4.625,4.1,4.1,0,0,0,4.655,10.1,4.042,4.042,0,0,1,2.8,9.6v.045a4.118,4.118,0,0,0,3.284,4.028,4.107,4.107,0,0,1-1.075.135,3.627,3.627,0,0,1-.776-.07,4.138,4.138,0,0,0,3.83,2.855,8.233,8.233,0,0,1-5.082,1.748A7.719,7.719,0,0,1,2,18.283a11.541,11.541,0,0,0,6.288,1.84A11.587,11.587,0,0,0,19.958,8.459c0-.182-.007-.357-.015-.53A8.2,8.2,0,0,0,22,5.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4c8166f2cb5f6b632423dca7c25f1468.svg";
export { ForwardRef as ReactComponent };